<!-- <template>
  <el-tooltip
    content="Sidebar toggle"
    effect="light"
    :open-delay="300"
    placement="right"
    style="background-color: transparent;"
  >
    <img src="@/assets/img/AFES_jkkp.png" style="width: 100px"

      @click="minimizeSidebar"
      rel="tooltip"
      data-original-title="Sidebar toggle"
      data-placement="right"
    />
    
  </el-tooltip>
</template>
<script>
export default {
  name: "sidebar-toggle-button",
  methods: {
    minimizeSidebar() {
      // Remove this code if you don't want to display notifications while minimizing sidebar
      let isMinimizedText = this.$sidebar.isMinimized
        ? "deactivated"
        : "activated";
      this.$notify({
        type: "primary",
        message: `Sidebar mini ${isMinimizedText}...`,
        icon: "tim-icons icon-bell-55",
      });
      this.$sidebar.toggleMinimize();
    },
  },
};
</script>
<style></style> -->

<template>
  <!-- <el-tooltip
    content="Sidear toggle"
    effect="light"
    :open-delay="300"
    placement="right"
  > -->
    <button
      class="minimize-sidebar btn btn-link btn-just-icon"
      @click="minimizeSidebar"
      rel="tooltip"
      data-original-title="Sidebar toggle"
      data-placement="right"
    >
      <i class="fa fa-bars visible-on-sidebar-regular" style="font-size: 25px;"></i>
      <i class="fa fa-bars visible-on-sidebar-mini" style="font-size: 23px;"></i>
    </button>
  <!-- </el-tooltip> -->
</template>
<script>
export default {
  name: 'sidebar-toggle-button',
  methods: {
    minimizeSidebar() {
      // Remove this code if you don't want to display notifications while minimizing sidebar
      let isMinimizedText = this.$sidebar.isMinimized
        ? 'deactivated'
        : 'activated';
      this.$notify({
        type: 'primary',
        message: `Sidebar mini ${isMinimizedText}...`,
        icon: 'tim-icons icon-bell-55'
      });
      this.$sidebar.toggleMinimize();
    }
  }
};
</script>
<style></style>

